import { Css } from "src/Css";

interface PageTitleProps {
  title: string;
}

export function PageTitle({ title }: PageTitleProps) {
  return <div css={Css.mtPx(60).mb4.header24.ifXs.mt6.mt3.$}>{title}</div>;
}
